<script setup>
import { computed } from 'vue'
import { usePage } from '@inertiajs/inertia-vue3'
import {Head, useForm} from "@inertiajs/inertia-vue3";
import UpdateProfileInformationForm from "./Partials/UpdateProfileInformationForm";
import UpdatePasswordForm from "./Partials/UpdatePasswordForm";
const props = defineProps({
  profile: Object,
  address: Object,
})

const customer = computed(() => usePage().props.value.auth.customer)

function updatePassword() {
  this.passwordForm.put(route('customer-password.update'), {
    errorBag: 'updatePassword',
    preserveScroll: true,
    onSuccess: () => this.form.reset(),
    onError: () => {
      if (this.form.errors.password) {
        this.form.reset('password', 'password_confirmation')
        this.$refs.password.focus()
      }

      if (this.form.errors.current_password) {
        this.form.reset('current_password')
        this.$refs.current_password.focus()
      }
    }
  })
}

</script>

<template>
    <Head title="Mijn profiel" />

  <div class="max-w-7xl mx-auto py-10 sm:px-6 lg:px-8">

    <UpdateProfileInformationForm v-if="address" :address="props.address" class="mb-4"/>

    <UpdatePasswordForm/>

  </div>

</template>
